import React, { Component } from 'react';
import { SubViewHeader } from '../../lib/components/subHeader';
import { IoteraForm } from '../../lib/components/form';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { isEmpty } from 'iotera-base/object'
import { isContainUppercase, hasWhiteSpace } from '../../lib/function';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "TAG_ADD";
const wBoundActions = buildWBoundActions(WKEY);

const schema = {
  "definitions": {
    "tags": {
      "title": "Tags",
      "type": "object",
      "properties": {
        "label": { type: "string", title: 'Nama', minLength: 1, maxLength: 32 },
        "key": { type: "string", title: 'Nama Kunci', maxLength: 32 },
        "tipe": {
          "title": "Tipe",
          "type": "string",
          "enum": [
            "Single",
            "Multi",
          ]
        }
      },
      "required": [
        "label", "tipe"
      ],
      "dependencies": {
        "tipe": {
          "oneOf": [
            {
              "properties": {
                "tipe": {
                  "enum": [
                    "Single"
                  ]
                },
                "masukan": {
                  "title": "Masukan",
                  "type": "string",
                  "enum": [
                    "Single Selection",
                    "Single Checkbox",
                    "Single Value",
                  ]
                },
              },
              "required": [
                "masukan"
              ],
              "dependencies": {
                "masukan": {
                  "oneOf": [
                    {
                      "properties": {
                        "masukan": {
                          "enum": [
                            "Single Checkbox"
                          ]
                        }
                      }
                    },
                    {
                      "properties": {
                        "masukan": {
                          "enum": [
                            "Single Selection"
                          ]
                        }
                      }
                    },
                    {
                      "properties": {
                        "masukan": {
                          "enum": [
                            "Single Value"
                          ]
                        }
                      }
                    }
                  ]
                }
              }
            },
            {
              "properties": {
                "tipe": {
                  "enum": [
                    "Multi Value"
                  ]
                }
              }
            }
          ]
        }
      }
    }
  },
  type: "object",
  required: ['type'],
  properties: {
    type: { title: 'Penanda', $ref: "#/definitions/tags" }
  }
};

class TagAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      value: '',
      selectedId: '',
      formData: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/tag/category/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {

                  _props.history.push('.' + S + '_tag_list_')
                  _props.showSingleNotification({ message: 'Tambah Penanda Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Tambah Penanda Gagal', position: 'tr', level: 'error' });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    let submitData = safeDeepGetWithType(event, ['formData', 'type'], {});
    let formData = safeDeepGetWithType(event, ['formData'], {});
    if (isEmpty(submitData)) {
      return;
    }
    const name = safeDeepGetWithType(submitData, ['label'], '').trim();
    let keyName = safeDeepGet(submitData, ['key'], null);
    const masukan = safeDeepGetWithType(submitData, ['masukan'], '').toLowerCase();
    const tipe = safeDeepGetWithType(submitData, ['tipe'], '').toLowerCase();
    let category = 0;
    if (keyName !== null) {
      _this.setState({ formData })
      if (isContainUppercase(keyName)) {
        _props.showSingleNotification({ message: 'Nama kunci tidak boleh mengandung huruf besar!', level: 'error' });
        return;
      } else if (hasWhiteSpace(keyName)) {
        _props.showSingleNotification({ message: 'Nama kunci tidak boleh mengandung spasi!', level: 'error' });
        return;
      }
    } else {
      keyName = name.toLowerCase().replace(/ /g, "_");
    }
    if (tipe === "single") {
      if (masukan === "single selection") {
        category = 1;
      } else if (masukan === "single checkbox") {
        category = 3;
      } else {
        category = 2;
      }
    } else {
      category = 4;
    }
    _this.setState({ loading: true, formData });
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        name,
        prefix: keyName,
        category
      }
    });
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Tag' subTitle='Formulir Tambah Tag' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema}
              onSubmit={_this.handleSubmit}
              formData={_state.formData}
            >
              <div className="button-right">
                <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                  onClick={(e) => _props.history.push('.' + S + '_tag_list_')} >Batal</button>
                <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};


export default connect(null, mapDispatchToProps)(withRouter(TagAdd));